






























































import { Component, Vue, Prop } from "vue-property-decorator";
import { mappingData } from "@/utils/utils";
import {
  editRole,
  addRole,
  treeselect as menuTreeselect,
  roleMenuTreeselect
} from "@/api/system/role";
import { treeselect } from "@/api/system/dept";
import { getDicts } from "@/api/system/data";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
@Component({
  props: {
    addOrEditModal: {
      default: false,
      type: Boolean
    },
    addOrEditFlag: {
      type: Boolean
    },
    list: {
      type: Object
    }
  },
  components: {
    Treeselect
  }
})
export default class AddOrEdit extends Vue {
  public ruleForm = {
    deptId: null,
    roleName: "",
    remark: "",
    status: "0",
    menuIds: []
  };
  statusOptions = [];
  public rules = {
    deptName: [{ required: true, message: "请输入部门名称", trigger: "blur" }],
    comp: [{ required: true, message: "请输入所属公司", trigger: "blur" }],
    leader: [{ required: true, message: "请输入部门领导", trigger: "blur" }],
    UpdeptName: [{ required: true, message: "请选择上级部门", trigger: "blur" }]
  };
  public menuOptions = [];
  public changeDialogVisible = false;
  public defaultProps = {
    children: "children",
    label: "label"
  };
  private deptOptions = [];
  public created() {
    this.changeDialogVisible = this.addOrEditModal;
    this.getTreeselect();
    this.getDicts("sys_normal_disable").then(response => {
      this.statusOptions = response.data;
    });
    if (!this.addOrEditFlag) {
      //this.ruleForm = this.list;
      this.ruleForm = mappingData(this.list, this.ruleForm);
      this.$nextTick(() => {
        this.getRoleMenuTreeselect(this.list.roleId);
      });
    } else {
      this.getMenuTreeselect();
    }
  }
  /** 查询部门下拉树结构 */
  getTreeselect() {
    treeselect().then(response => {
      this.deptOptions = response.data;
    });
  }
  /**
   * 表单验证 修改密码接口
   * params formName form表单的ref
   */
 
  public submitForm(formName) {
    const params = this.addOrEditFlag
      ? this.ruleForm
      : Object.assign(
          {},
          {
            roleId: this.list.roleId
          },
          this.ruleForm
        );
    const that = this;
    this.$refs[formName].validate(valid => {
      if (valid) {
        if (this.addOrEditFlag) {
          params.menuIds = this.getMenuAllCheckedKeys();
          addRole(params).then(response => {
            if (response.code === 200) {
              this.$message.success("新增成功");
              this.changeDialogVisible = false;
              this.$emit("showModal", this.changeDialogVisible);
            } else {
              this.$message.error(response.msg);
            }
          });
        } else {
          params.menuIds = this.getMenuAllCheckedKeys();
          editRole(params).then(response => {
            if (response.code === 200) {
              this.$message.success("编辑成功");
              this.changeDialogVisible = false;
              this.$emit("showModal", this.changeDialogVisible);
            } else {
              this.$message.error(response.msg);
            }
          });
        }
      } else {
        return false;
      }
    });
  }
  /**
   * 还原表单验证
   * params formName form表单的ref
   */

  public resetForm(formName) {
    this.$refs[formName].resetFields();
    this.changeDialogVisible = false;
    this.$emit("showModal", this.changeDialogVisible);
  }
  // 所有菜单节点数据
  public getMenuAllCheckedKeys() {
    // 目前被选中的菜单节点
    const checkedKeys = this.$refs.menu.getHalfCheckedKeys();
    // 半选中的菜单节点
    const halfCheckedKeys = this.$refs.menu.getCheckedKeys();
    checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys);
    return checkedKeys;
  }
  /** 查询菜单树结构 */
  public getMenuTreeselect() {
    menuTreeselect().then(response => {
      this.menuOptions = response.data;
    });
  }
  /** 根据角色ID查询菜单树结构 */
  public getRoleMenuTreeselect(roleId) {
    roleMenuTreeselect(roleId).then(response => {
      this.getMenuTreeselect();
      this.$refs.menu.setCheckedKeys(response.data);
    });
  }
}
